import type { GetParameters } from "../../../../request/hooks/openApi/useOpenApiQuery";

export const KEY_COMMUNITIES_ADMIN_USERS_BASE =
  "communities-admin-users" as const;
const urlBackendPath = "/communities/{community_id}/admin/users" as const;

type QueryParameters = GetParameters<typeof urlBackendPath>["query"];

export const keyCommunitiesAdminUsers = (
  props: QueryParameters & { id: number },
) => [
  KEY_COMMUNITIES_ADMIN_USERS_BASE,
  props.id.toString(),
  props.filter_by_role_id ?? "",
  props.filter_by_is_admin ?? "",
  props.search ?? "",
  props.sort_by ?? "",
  props.sort_direction ?? "",
];
